import React from 'react';
//import Header from '../../components/Header';
import SideBar from './SideBar';
// import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
const AdminLayout = () => {
  useEffect(() => {
    
    document.title = "Admin - Technical Paper Platform";
  }, []);
    return (
        <div className="wrapper">
        {/* <Header /> */}
        <SideBar />
  
        <div className="content-wrapper" style={{ marginLeft: 250, minHeight: '100vh' }}>
          <section className="content pt-3 px-3">
            <div className="container-fluid">
            <Outlet />
            </div>
          </section>
        </div>
  
        <Footer />
      </div>
    );
};

export default AdminLayout;